import React from 'react';
import { Table, TableRow, TableHeaderCell } from 'semantic-ui-react';

export default function FertilizerPrintWorksheetCompletionDetailsTableHeader(): React.ReactElement {
    return (
        <Table.Header>
            <TableRow>
                <TableHeaderCell>Orchard</TableHeaderCell>
                <TableHeaderCell>Blocks</TableHeaderCell>
                <TableHeaderCell>Hectares</TableHeaderCell>
            </TableRow>
        </Table.Header>
    );
}
